export const aboutData = {
    title: "Whats hashbrown.dev ?",
    description1: "Hashbrowns are my favories!!! So why not to give a space for my favorite porojects too? Hashbrowns dev is my personal space for things I do around Blockchain, web3 and decentralized systems. ",
    description2: "",
    image: 1
}